export const address = "0xAB8C867A8BF0C9eC800cfED5236c14E78e324926";
export const NFTaddress = "0x4C91f2b0ee8030D5B810C951B7CE5201aE915550";
// export const NFTaddress = "0x4873940fF4De4Ce8fC634FC2AA8e5d8267F26A3E";
// export const NFTaddress = "0x6c8dc2802521a69C06aD672020eeB3ea432FB77A";
// export const NFTaddress = "0x99b5e1BBF01A1061747DA2cc1e2EcD585AF6A0fE";
// export const address = "0x80b43f81d2AB12584d131818570817452B96849F";
// export const NFTaddress = "0x74595ccE6b8D58764C9902B8007b779bb5EE1d08";
// // export const NFTaddress = "0xCf3A01F472d5ab1Aa14c7a90537B34725cE0AD5d";
